import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const STONE = "#8d8a85";
const STONE_DK = "#6f6c67";

function rockUnit(cx: number, cy: number, cz: number, s: number, c: string): Part[] {
  return [{ geometry: new THREE.IcosahedronGeometry(s, 0), color: c, position: [cx, cy, cz], scale: [1, 0.8, 0.92] as const }];
}

export const stonePile = defineModel({
  id: "stone-pile",
  batchId: "characters",
  name: "Stone pile",
  tags: ["good", "cargo", "stone"],
  fits: ["carry"],
  summary: "A handful of rough stones -- a carriable good for an avatar's carry socket.",
  description:
    "Three varied stones at held scale, ported from age-of-mcp's goods (`stone`). " +
    "Mount it in a player's or worker's `carry` socket to show the figure " +
    "hauling stone.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => [
    ...rockUnit(0, 0.05, 0.01, 0.07, STONE),
    ...rockUnit(0.05, 0.035, 0.03, 0.045, STONE_DK),
    ...rockUnit(-0.05, 0.035, -0.01, 0.04, STONE_DK),
  ],
  animations: [],
});
